import React from 'react';

const SplashScreen = () => <></>;

export default SplashScreen;
